import React from 'react';
import PropTypes from 'prop-types';

const EditText = ({ 
  placeholder = "", 
  value, 
  onChange, 
  type = "text",
  disabled = false,
  className = "",
  ...props 
}) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`
        w-full 
        bg-global-6 
        text-global-7 
        text-xs sm:text-sm lg:text-[14px] 
        font-svn-gilroy 
        font-medium 
        leading-[15px] 
        border 
        border-global-7 
        rounded-[8px] 
        py-2 sm:py-3 lg:py-[14px] 
        px-4 sm:px-6 lg:px-7
        focus:outline-none 
        focus:ring-2 
        focus:ring-global-text4 
        focus:border-global-text4
        disabled:bg-gray-100 
        disabled:cursor-not-allowed
        transition-all 
        duration-200
        ${className}
      `?.trim()?.replace(/\s+/g, ' ')}
      {...props}
    />
  );
};

EditText.propTypes = {
  placeholder: PropTypes?.string,
  value: PropTypes?.string,
  onChange: PropTypes?.func,
  type: PropTypes?.string,
  disabled: PropTypes?.bool,
  className: PropTypes?.string,
};

export default EditText;